import axios from 'axios'
import store from '@/store'
import apiErrorHandler from '../utils/apiErrorHandler'
async function getEconomicGroupProviderSponsors(groupId, providerId) {
    try {
        store.commit('user/setLoading', true)
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/economicgroup/${groupId}/provider/${providerId}/sponsors`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        })
        store.commit('user/setLoading', false)
        return result
    } catch (e) {
        store.commit('user/setLoading', false)
        apiErrorHandler(e.response)
        return e.response
    }

}

export default getEconomicGroupProviderSponsors